module.exports = __webpack_public_path__ + "img/ios.d154ddc8.png";